function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delivery_truck",
  "data-name": "delivery truck"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M29,19a1,1,0,0,0,1-1V16.76a2.05,2.05,0,0,0-1.42-2l-1.69-.56-.52-3A4.17,4.17,0,0,0,22.09,8H19V5.89A1.88,1.88,0,0,0,17.11,4h0L4,4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h.08a4,4,0,0,0,0,.5,3.52,3.52,0,1,0,1-2.49H5L4,22,4,6,17,6V22H14a1,1,0,0,0,0,2h5.88a2.73,2.73,0,0,0-.05.5,3.6,3.6,0,0,0,6.44,2.11A3.38,3.38,0,0,0,27,24.5a4,4,0,0,0,0-.5H28a2,2,0,0,0,2-2,1,1,0,0,0-1-1,1,1,0,0,0-1,1H25.9a3.56,3.56,0,0,0-2.49-1,3.65,3.65,0,0,0-2.52,1H19V16h6.79l2.21.76V18A1,1,0,0,0,29,19ZM7.5,23A1.5,1.5,0,1,1,6,24.5,1.5,1.5,0,0,1,7.5,23Zm15.91,0a1.6,1.6,0,0,1,1.28.61,1.43,1.43,0,0,1,0,1.78,1.6,1.6,0,0,1-1.28.61,1.5,1.5,0,1,1,0-3ZM22.09,10a2.22,2.22,0,0,1,2.31,1.57L24.82,14H19V10Z"
}));

var SvgDeliveryTruck = function SvgDeliveryTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deliveryTruck.1a938318.svg";
export { ForwardRef as ReactComponent };